import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumFormatModalComponent } from './num-format-modal.component';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { FormsModule } from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { I18nInputModule } from '../config-editor2/i18n-input/i18n-input.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [NumFormatModalComponent],
  imports: [
    CommonModule,
    NzInputNumberModule,
    FormsModule,
    NzSelectModule,
    I18nInputModule,
    TranslateModule
  ]
})
export class NumFormatModalModule { }
